import React from 'react';
import { useSocket } from '@hooks/useSocket';
import { useGameStore } from '@store/gameStore';
import styles from './GameControls.module.css';

export const GameControls: React.FC = () => {
  const gameState = useGameStore((state) => state.gameState);
  const { resign, offerDraw } = useSocket();
  
  const handleResign = () => {
    if (window.confirm('Are you sure you want to resign?')) {
      resign();
    }
  };
  
  const handleOfferDraw = () => {
    offerDraw();
  };
  
  const isGameActive = gameState?.gameStatus === 'active';
  
  return (
    <div className={styles.controls}>
      <button
        onClick={handleOfferDraw}
        disabled={!isGameActive}
        className={`${styles.button} ${styles.drawButton}`}
      >
        Offer Draw
      </button>
      <button
        onClick={handleResign}
        disabled={!isGameActive}
        className={`${styles.button} ${styles.resignButton}`}
      >
        Resign
      </button>
    </div>
  );
};